<template>
  <div class="w-full">
    <div class="fixed top-0 left-0 w-full">
      <img src="../../assets/images/onboarding-banner.png" class="w-full h-auto pointer-events-none"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Onboarding',

  methods: {
    ...mapActions({
      openModal: 'dialogs/openModal'
    })
  },
  computed: {
    ...mapGetters({
      'userOnboardingState': 'app/onboardingState'
    })
  },
  mounted() {
    if (this.userOnboardingState === '1' || this.$router.history.current.query.debug === 'true') {
      this.openModal({ name: 'WelcomeModal' })
    } else {
      this.$router.push('/drive')
    }
  }
}
</script>

<style>

</style>
